import React from 'react';
import { Globe2 } from 'lucide-react';

/**
 * Reassures Latin American buyers that the USD price is charged
 * in their own currency at checkout.
 */
export const LocalCurrencyNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={`mx-auto w-full max-w-[320px] rounded-[14px] border border-brandIndigo-electric/60 bg-bg-card px-3 py-2.5 ${className}`} data-id="element-371" data-mp="103h6o5psvpr3">
    <div className="flex items-start gap-2" data-id="element-372" data-mp="q6mahth021fz">
      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brandViolet/15 text-brandViolet" data-id="element-373" data-mp="q8fhxazfspp1">
        <Globe2 size={13} aria-hidden="true" data-id="element-374" data-mp="leb7ghqypzj7" />
      </span>
      <div className="min-w-0 text-left" data-id="element-375" data-mp="hfc95fzql10q">
        <p className="font-sans font-bold uppercase tracking-[1.2px] text-[9.5px] md:text-[10px] text-brandViolet" data-id="element-376" data-mp="hc6ku2yxm362">
          Pagas en tu moneda local
        </p>
        <p className="font-sans text-[10.5px] md:text-[11.5px] leading-[1.4] text-txt-body mt-0.5" data-id="element-377" data-mp="7fv490sb6r5t">
          El precio se convierte automáticamente al finalizar la compra.
        </p>
      </div>
    </div>
  </div>;